import React, { useState } from 'react';
import logo from '../images/logo_safety100_mice.svg';
import { AiOutlineMenu } from 'react-icons/ai';
import Sidebar from './Sidebar';
import Terms from './modal/Terms';
import PassCard from './modal/PassCard';

export default function NavbarLogo() {
  const [sidebar, setSidebar] = useState(false);
  const [terms1, setTerms1] = useState(false);
  const [passCard, setPassCard] = useState(false);
  const [terms3, setTerms3] = useState(false);
  const fn_showSideBar = () => {
    setSidebar(true)
  }
  return (
    <>
      {passCard && <PassCard setPassCard={setPassCard} />}
      {terms1 && <Terms setTerms1={setTerms1} terms1 service side />} {terms3 && <Terms setTerms3={setTerms3} terms3 side />}
      {sidebar && <Sidebar setSidebar={setSidebar} setTerms1={setTerms1} setTerms3={setTerms3} setPassCard={setPassCard} />}
      <div className='w-full h-[52px] md:h-[130px] flex justify-between items-center'>
        <p />
        <img className='h-[1.3rem] md:h-52 ml-[3.125rem] md:ml-[125px]' src={logo} alt='logo' />
        <AiOutlineMenu onClick={fn_showSideBar} className='text-[1.313rem] md:text-52 mr-[1.25rem] md:h-50 md:w-[50px] md:mr-[50px]' />
      </div>
    </>
  );
}

